import React from "react";
import BlockMapper from "modules/forms/hosted/blocks/BlockMapper";
import useForm from "modules/forms/hooks/useForm";

export default function AuthenticateSuccess() {
    const { form } = useForm();
    const authSuccessPage = form.pages.find(p => p.type == "auth_success");

    return (
        <div className={`flex-col items-center justify-center`}>
            {authSuccessPage.blocks.map(block => (
                <BlockMapper
                    block={block}
                    key={block.name}
                />
            ))}
        </div>
    );
}
